import { TRANSCRIBER_PROGRAM_CODE } from "./TranscriberProgramConstants";

const DEFAULT_IDENTITY_FIELD = {
  formSectionKey: "Global Switch Id",
  formFieldKey: "globalSwitchId",
};

export const TRANSCRIBER_DETAILS_CONFIG = {
  [TRANSCRIBER_PROGRAM_CODE.STD]: {
    transcriptionIdAlertLabel: "Transcription Id",
    readOnly: false,
    showSaveForm: true,
    identityField: {
      ...DEFAULT_IDENTITY_FIELD,
      headerLabel: "Global Switch ID",
    },
  },
  [TRANSCRIBER_PROGRAM_CODE.DMR]: {
    transcriptionIdAlertLabel: "DMR Transcription Id",
    readOnly: true,
    showSaveForm: false,
    identityField: {
      ...DEFAULT_IDENTITY_FIELD,
      headerLabel: "Fax Reference Id",
    },
  },
};

export const getTranscriberDetailsConfig = (
  programCode = TRANSCRIBER_PROGRAM_CODE.STD
) =>
  TRANSCRIBER_DETAILS_CONFIG[programCode] ??
  TRANSCRIBER_DETAILS_CONFIG[TRANSCRIBER_PROGRAM_CODE.STD];

export const getTranscriberIdentityFieldValue = (formData, identityField) => {
  const section = formData?.[identityField?.formSectionKey];
  const field = section?.[identityField?.formFieldKey];
  return field?.val ?? "";
};

export const omitTranscriberIdentitySection = (formData, identityField) => {
  if (!formData || !identityField?.formSectionKey) {
    return formData ?? {};
  }

  const { [identityField.formSectionKey]: _removed, ...formSections } = formData;
  return formSections;
};
